import type { SxProps, Theme } from '@mui/material/styles'

export const uiPalette = {
  primary: '#0A9BCD',
  selectedBg: '#C7ECF6',
  hoverBg: '#F2F2F2',
  disabledBg: '#D4D4D4',
  disabledText: '#9E9E9E',
  white: '#ffffff',
  dropdownBorder: '#e0e0e0',
}

export const checkboxPrimarySx = {
  color: uiPalette.primary,
  '&.Mui-checked': {
    color: uiPalette.primary,
  },
  '&.MuiCheckbox-indeterminate': {
    color: uiPalette.primary,
  },
}

export const deviceListActionButtonSx = {
  backgroundColor: uiPalette.primary,
  color: uiPalette.white,
  borderRadius: '8px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: uiPalette.primary,
  },
}

export const successSnackbarAlertSx = {
  width: '100%',
  minWidth: 220,
  fontWeight: 700,
  backgroundColor: '#1AB176',
}

export const dropdownBackdropSx = {
  position: 'fixed',
  inset: 0,
  zIndex: 1299,
}

export const dialogLoadingOverlaySx = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  zIndex: 1500,
  borderRadius: '4px',
}

export const dialogCancelButtonSx = {
  minWidth: 130,
  backgroundColor: '#f2f2f2',
  color: '#282828',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e6e6e6',
},
}

export const dialogSaveButtonSx = (enabled: boolean) => ({
  minWidth: 130,
  backgroundColor: enabled ? '#0a9bcd' : uiPalette.disabledBg,
  color: enabled ? uiPalette.white : uiPalette.disabledText,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: enabled ? '#0a9bcd' : uiPalette.disabledBg,
  },
})

export const selectableRowSx = (selected: boolean) => ({
  backgroundColor: selected ? uiPalette.selectedBg : 'transparent',
  '&:hover': {
    backgroundColor: selected ? uiPalette.selectedBg : uiPalette.hoverBg,
  },
  cursor: 'pointer',
})

export const dropdownMenuSx = (maxHeight: number) => ({
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  right: 0,
  backgroundColor: '#ffffff',
  border: '1px solid #e0e0e0',
  borderTop: 'none',
  borderRadius: '4px',
  zIndex: 1300,
  maxHeight: maxHeight,
  overflowY: 'auto',
  overflowWrap: 'anywhere',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
})

export const dialogActionsSx = (bottomPadding: number = 6) => ({
  justifyContent: 'center',
  gap: 3,
  pt: 2,
  pb: bottomPadding,
  position: 'relative',
  zIndex: 1400,
  flexShrink: 0,
})

export const dropdownSearchInputSx = (open: boolean): SxProps<Theme> => ({
  flex: 1,
  minWidth: 100,
  '& .MuiInput-root': {
    fontSize: '0.875rem',
    alignItems: 'center',
    height: '42px',
    lineHeight: '42px',
  },
  '& .MuiInput-input': {
    p: 0,
  },
  '& .MuiInput-input::placeholder': {
    color: '#9E9E9E',
    opacity: 1,
  },
})

export const dropdownFieldsetSx = (open: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 0.5,
  px: 1,
  py: '8px',
  border: open ? '2px solid #0A9BCD' : '1px solid #e0e0e0',
  borderRadius: '4px',
  backgroundColor: '#ffffff',
  cursor: 'text',
  transition: 'border-color 0.3s',
  minHeight: 40,
  alignContent: 'flex-start',
  m: 0,
})
